/*
 * @Author: LiuGuangMing
 * @Date: 2018-12-07 16:45:55
 * @Last Modified by: LiuGuangMing
 * @Last Modified time: 2019-02-25 10:04:49
 */
<template>
    <div class="container">
        <div :class="{content: true, empty: listData && listData.length === 0}">
            <div class="panel room">
                <ul>
                    <li class="day">
                        <label class="day">天数</label>
                        <div class="select-box day" v-if="global">
                            <span @click="toggleSelect()" :class="{down:select.on,notEmpty:selectedDay.title}">{{selectedDay.title}}</span>
                            <dl v-if="select.on">
                                <li v-for="(item,index) in global.list" :key="index" @click="selectUp(item)" :class="{active:item.selected}" class="listItem">{{item.title}}</li>
                            </dl>
                        </div>
                    </li>
                </ul>
                <ul>
                    <li>
                        <button @click="output('doc')">导出Word</button>
                        <button @click="output('excel')">导出Excel</button>
                    </li>
                </ul>
            </div>
            <div class="line">
                <p></p>
            </div>
            <div :class="{table: true, room: true, empty: listData && listData.length === 0}">
                <dl>
                    <li v-if="listData && listData.length > 0">
                        <dt>提案标题</dt>
                        <dt>完成工作</dt>
                        <dt>计划安排</dt>
                        <dt>需要协调</dt>
                    </li>
                    <empty :mTop="50" v-if="listData && listData.length === 0" :msg="'暂无提案数据'" />
                    <li v-for="(item,index) in listData" :key="index">
                        <dd :title="item.title" @click="openDetail(item)">
                            <label class="title">{{item.title}}</label>
                            <span>{{item.user_name}}</span>
                            <span>{{item.push_time}}</span>
                        </dd>
                        <dd class="fiveline">{{item.finished_work}}</dd>
                        <dd class="fiveline">{{item.plan}}</dd>
                        <dd class="fiveline">{{item.coordination || '暂无'}}</dd>
                    </li>
                </dl>
            </div>
            <pages :page_count="page.page_count" :index="page.pageIndex" :total="page.total"></pages>
            <!-- 弹出 -->
            <div class="dialog" v-if="dialog.show">
                <div class="infoSee">
                    <div class="top">
                        <h4>{{dialog.detail.title}}</h4>
                        <span @click="closeDetail"></span>
                    </div>
                    <ul>
                        <li class="info">
                            <span>{{dialog.detail.user_name}}</span>
                            <span>{{dialog.detail.push_time}}</span>
                        </li>
                        <li>
                            <label>完成工作</label>
                            <p class="detailPart">{{dialog.detail.finished_work || '暂无'}}</p>
                        </li>
                        <li>
                            <label>计划安排</label>
                            <p class="detailPart">{{dialog.detail.plan || '暂无'}}</p>
                        </li>
                        <li>
                            <label>需要协调</label>
                            <p class="detailPart">{{dialog.detail.coordination || '暂无'}}</p>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {apis} from '@common/config'
import common from '@common/common'
import pages from '@components/pages'
import empty from '@components/empty'

export default{
    components: { pages, empty},
    data (){

        return{

            listData: null,

            page: {
              pageIndex: 1,

              pagesize: 10,

              page_count: 0,

              total: 0
            },

            backShow: false,

            select: {

                id: null,

                text: null,

                on: false,

                search_option: "",

                key_words: "",

                days: null
            },
            global: [],
            selectedDay: {},
            searchOptions: {},
            filterOptions: {},
            dialog: {
                show: false,
                detail: {}
            }
        }
    },
    methods: {
        closeDetail(){
            this.dialog = {
                show: false,
                detail: {}
            }
        },
        openDetail(i) {
            // 打开提案详情弹窗
            this.dialog = {
                show: true,
                detail: i
            }
        },
        //获取列表数据
        getList (){
            const id = this.$route.params.id
            let data = {
                idstring: id,
                days: '',
                search_option: '',
                key_words: '',
                page: this.page.pageIndex,
                pagesize: this.page.pagesize
            }

            this.searchOptions.key_words = this.$store.state.keyWord

            Object.assign(data, this.searchOptions, this.filterOptions)

            common.myFetch(apis.proposalLibrary, data)
            .then((res) => {
                this.listData = res.list
                this.$set(this.page, 'page_count', common.calculatePage(res.page.row_count - 0, this.page.pagesize))
                // this.pagesize = res.page.pagesize;
                // this.generateSearchs(res.params.top_search);
                this.$set(this.page, 'total', res.page.row_count - 0)
                this.generateSearchs(res.params.top_search[0].list)
                this.global = res.params.list_search[0]
                this.autoSelectDay()
                // if(!this.select.text){
                //     this.select.text = res.params.list_search[0].list[0].title;
                // }
            })
        },
        autoSelectDay() {
          this.global.list.forEach(i => {
            if (i.selected) {
              // this.selectUp(i)
              this.selectedDay = i
              this.filterOptions['days'] = i.key
            }
          })
        },
        //返回顶部搜索相关
        generateSearchs(data) {
          // 整理搜索栏数据
          const types = data.map((i) => {
            return {
              name: i.title,
              code: i.key,
              selected: i.selected
            }
          })

          const filterData = {
            types: types,
            callback: (o) => {
              this.getSearch(o)
            }
          }
          this.postSearch(filterData)
        },
        getSearch(d) {
          // 接收搜索框数据
          this.searchOptions = d
          this.page.pageIndex = 1
          this.getList()
        },
        postSearch(data) {
          // 发送搜索框数据
          this.$emit('filterData', data)
        },
        // generateSearchs(data) {
        //     const types = data.map((i) => {
        //         return {
        //         name: i.title,
        //         code: i.key,
        //         selected: i.selected
        //         }
        //     })
        //
        //     const filterData = {
        //         types: types,
        //         callback: (o) => {
        //
        //             this.getList(o,this.select.days)
        //
        //             this.select.search_option = o.search_option;
        //
        //             this.select.key_words = o.key_words;
        //         }
        //     }
        //
        //     this.postSearch(filterData)
        // },
        // postSearch(data) {
        //     this.$emit('filterData', data)
        // },
        toggleSelect() {
          this.select.on = !this.select.on;
        },
        selectUp (i){
            if (this.filterOptions['days'] === i.key) {
              this.select.on = false
              return
            }

            this.page.pageIndex = 1

            this.selectedDay = i
            this.filterOptions['days'] = i.key
            this.getList()
            this.select.on = false
        },
        //导出数据
        output (type){
            let info = {
                download_type: type,
                days: this.filterOptions.days || '',
                search_option: this.searchOptions.search_option || '',
                key_words: this.searchOptions.key_words || ''
            }

            const userKeys = common.userKeys();
            const params = Object.assign({}, info, userKeys);
            const url = apis.proposalExport;

            common.exportRes(url, params)
        }
    },
    mounted() {

        this.getList();
        //滚动条
        // window.addEventListener('scroll', this.handleScroll);
    }
}
</script>

<style src="@assets/css/proposal/proposal.less" lang="less" scoped></style>
